// test827
(827 && 0);
